import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-097b1433")

_pushScopeId("data-v-097b1433")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "nav__title" }, "Detalhamento de inventário", -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "header"
}
const _hoisted_5 = {
  class: "header__name",
  "data-test": "headerName"
}
const _hoisted_6 = {
  class: "header__quantity",
  "data-test": "headerQuantity"
}
const _hoisted_7 = { class: "list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_OButton = _resolveComponent("OButton")
  const _component_InventorySummaryItem = _resolveComponent("InventorySummaryItem")
  const _component_ListWrapper = _resolveComponent("ListWrapper")
  const _component_BlockUI = _resolveComponent("BlockUI")
  const _component_InventorySummaryDialog = _resolveComponent("InventorySummaryDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BlockUI, { blocked: _ctx.busy }, {
      default: _withId(() => [
        _createVNode(_component_NavBar, { navigation: "back" }, {
          body: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_3, [
          (_ctx.loaded)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.header.name), 1),
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.header.quantity) + " UN ", 1),
                (_ctx.viewMode === 'P' && _ctx.header.quantity > 0)
                  ? (_openBlock(), _createBlock(_component_OButton, {
                      key: 0,
                      class: "p-button-primary p-button-outlined",
                      label: "Esvaziar açude",
                      loading: _ctx.draining,
                      "data-test": "drainPond",
                      onClick: _ctx.handleDrainPond
                    }, null, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            (_ctx.loaded)
              ? (_openBlock(), _createBlock(_component_OButton, {
                  key: 0,
                  class: "p-button-text p-button-primary btn-add-item",
                  icon: "pi pi-plus-circle",
                  "icon-pos": "right",
                  label: _ctx.addItemLabel,
                  "data-test": "addItem",
                  onClick: _ctx.addItem
                }, null, 8, ["label", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ListWrapper, {
              records: _ctx.body,
              loading: !_ctx.loaded,
              error: _ctx.error.body,
              "error-msg": "Não foi possível carregar seu inventário.",
              "reload-cb": _ctx.loadBody
            }, {
              default: _withId((slotProps) => [
                _createVNode(_component_InventorySummaryItem, {
                  inventory: slotProps.record,
                  onClick: ($event: any) => (_ctx.openInventorySummaryDialog(slotProps.record))
                }, null, 8, ["inventory", "onClick"])
              ]),
              _: 1
            }, 8, ["records", "loading", "error", "reload-cb"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["blocked"]),
    _createVNode(_component_InventorySummaryDialog, {
      visible: _ctx.inventorySummaryDialogVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inventorySummaryDialogVisible = $event)),
      onViewHistory: _ctx.handleViewHistory,
      onCreateIn: _ctx.handleCreateIn,
      onCreateOut: _ctx.handleCreatOut,
      onCreateTransfer: _ctx.handleCreateTransfer
    }, null, 8, ["visible", "onViewHistory", "onCreateIn", "onCreateOut", "onCreateTransfer"])
  ]))
})